import React from 'react';

// CSS spinner (replaces the Bootstrap Spinner). Grayscale; respects reduced motion.
export const Spinner = ({ className = '' }: { className?: string }) => (
    <span
        role="status"
        aria-label="Loading"
        className={`inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-tone-300 border-t-ink motion-reduce:animate-none ${className}`}
    />
);
